import React from 'react';
import { X, Linkedin, Facebook, Instagram, Github } from 'lucide-react';
interface FooterProps {
  'data-id'?: string;
}
export function Footer({
  'data-id': dataId
}: FooterProps) {
  return <footer className="w-full bg-white border-t border-benetton-green relative overflow-hidden" data-id="element-110">
      {/* Decorative paint stroke elements */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none" data-id="element-111">
        <div className="absolute top-8 left-4 w-24 h-1 bg-gradient-to-r from-benetton-violet to-transparent transform -rotate-12 opacity-60" data-id="element-112"></div>
        <div className="absolute top-12 left-8 w-16 h-1 bg-gradient-to-r from-benetton-green to-transparent transform -rotate-6 opacity-40" data-id="element-113"></div>
        <div className="absolute top-16 right-8 w-32 h-1 bg-gradient-to-l from-benetton-red to-transparent transform rotate-12 opacity-50" data-id="element-114"></div>
        <div className="absolute bottom-12 left-1/4 w-28 h-1 bg-gradient-to-r from-benetton-blue to-transparent transform rotate-3 opacity-40" data-id="element-115"></div>
        <div className="absolute bottom-8 right-1/3 w-24 h-1 bg-gradient-to-l from-benetton-orange to-transparent transform -rotate-3 opacity-50" data-id="element-116"></div>
      </div>
      <div className="max-w-7xl mx-auto px-6 py-12 md:py-16 relative z-10" data-id="element-117">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8" data-id="element-118">
          {/* Logo and description */}
          <div className="col-span-1 md:col-span-1 lg:col-span-2" data-id="element-119">
            <div className="flex items-center gap-2 mb-4" data-id="element-120">
              {/* Logo image */}
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/09/FF_NAIOMI.png" alt="Naiomi AI Logo" className="h-16 w-auto" data-id="element-121" />
            </div>
            <p className="text-lg text-gray-600 max-w-md mb-6 font-jakarta" data-id="element-122">
              The first conversational AI platform designed specifically for
              eCommerce brands to turn scattered data into actionable insights.
            </p>
            <div className="flex space-x-4" data-id="element-123">
              <a href="#" className="text-gray-500 hover:text-black transition-colors" data-id="element-124">
                {/* Updated X logo to match current branding */}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-5 w-5 fill-current" data-id="element-125">
                  <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" data-id="element-126" />
                </svg>
                <span className="sr-only" data-id="element-127">X</span>
              </a>
              <a href="https://www.linkedin.com/company/naiomi-ai" className="text-gray-500 hover:text-black transition-colors" data-id="element-128">
                <Linkedin className="h-5 w-5" data-id="element-129" />
                <span className="sr-only" data-id="element-130">LinkedIn</span>
              </a>
            </div>
          </div>
          {/* Links */}
          <div data-id="element-131">
            <h3 className="text-sm font-semibold text-benetton-green uppercase tracking-wider mb-4" data-id="element-132">
              Product
            </h3>
            <ul className="space-y-3" data-id="element-133">
              <li data-id="element-134">
                <div className="flex flex-wrap items-center" data-id="element-135">
                  <a href="#" className="text-lg text-gray-600 hover:text-black transition-colors mr-2" data-id="element-136">
                    Features
                  </a>
                  <span className="text-xs px-2 py-1 bg-gray-100 text-gray-500 rounded-full whitespace-nowrap" data-id="element-137">
                    Coming soon
                  </span>
                </div>
              </li>
              <li data-id="element-138">
                <div className="flex flex-wrap items-center" data-id="element-139">
                  <a href="#" className="text-lg text-gray-600 hover:text-black transition-colors mr-2" data-id="element-140">
                    Integrations
                  </a>
                  <span className="text-xs px-2 py-1 bg-gray-100 text-gray-500 rounded-full whitespace-nowrap" data-id="element-141">
                    Coming soon
                  </span>
                </div>
              </li>
              <li data-id="element-142">
                <div className="flex flex-wrap items-center" data-id="element-143">
                  <a href="#" className="text-lg text-gray-600 hover:text-black transition-colors mr-2" data-id="element-144">
                    Pricing
                  </a>
                  <span className="text-xs px-2 py-1 bg-gray-100 text-gray-500 rounded-full whitespace-nowrap" data-id="element-145">
                    Coming soon
                  </span>
                </div>
              </li>
              <li data-id="element-146">
                <div className="flex flex-wrap items-center" data-id="element-147">
                  <a href="#" className="text-lg text-gray-600 hover:text-black transition-colors mr-2" data-id="element-148">
                    Roadmap
                  </a>
                  <span className="text-xs px-2 py-1 bg-gray-100 text-gray-500 rounded-full whitespace-nowrap" data-id="element-149">
                    Coming soon
                  </span>
                </div>
              </li>
            </ul>
          </div>
          <div data-id="element-150">
            <h3 className="text-sm font-semibold text-benetton-green uppercase tracking-wider mb-4" data-id="element-151">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-152">
              <li data-id="element-153">
                <div className="flex flex-wrap items-center" data-id="element-154">
                  <a href="#" className="text-lg text-gray-600 hover:text-black transition-colors mr-2" data-id="element-155">
                    About
                  </a>
                  <span className="text-xs px-2 py-1 bg-gray-100 text-gray-500 rounded-full whitespace-nowrap" data-id="element-156">
                    Coming soon
                  </span>
                </div>
              </li>
              <li data-id="element-157">
                <div className="flex flex-wrap items-center" data-id="element-158">
                  <a href="#" className="text-lg text-gray-600 hover:text-black transition-colors mr-2" data-id="element-159">
                    Blog
                  </a>
                  <span className="text-xs px-2 py-1 bg-gray-100 text-gray-500 rounded-full whitespace-nowrap" data-id="element-160">
                    Coming soon
                  </span>
                </div>
              </li>
              <li data-id="element-161">
                <div className="flex flex-wrap items-center" data-id="element-162">
                  <a href="#" className="text-lg text-gray-600 hover:text-black transition-colors mr-2" data-id="element-163">
                    Careers
                  </a>
                  <span className="text-xs px-2 py-1 bg-gray-100 text-gray-500 rounded-full whitespace-nowrap" data-id="element-164">
                    Coming soon
                  </span>
                </div>
              </li>
              <li data-id="element-165">
                <div className="flex flex-wrap items-center" data-id="element-166">
                  <a href="#" className="text-lg text-gray-600 hover:text-black transition-colors mr-2" data-id="element-167">
                    Contact
                  </a>
                  <span className="text-xs px-2 py-1 bg-gray-100 text-gray-500 rounded-full whitespace-nowrap" data-id="element-168">
                    Coming soon
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-benetton-green flex flex-col md:flex-row justify-between items-center" data-id="element-169">
          <p className="text-sm text-gray-500 mb-4 md:mb-0" data-id="element-170">
            &copy; {new Date().getFullYear()} Naiomi AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}